import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = (secret, token) =>
  axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : { "X-Admin-Secret": secret },
  });
